<ui-filter-container>
    @if (searchFilter(); as filter) {
        <ui-text-filter
            search-filter
            [filter]="filter.filter"
            [placeholder]="filter.placeholder"
        />
    }

    @for (filter of filters(); track filter.filter.key) {
        @switch (filter.type) {
            @case ('select') {
                <ui-dropdown-filter
                    [filter]="filter.filter"
                    [options]="filter.options"
                    [placeholder]="filter.placeholder"
                    (reloadFilterOptions)="reloadFilterOptions()"
                />
            }
            @case ('multiselect') {
                <ui-multi-select-filter
                    [filter]="filter.filter"
                    [options]="filter.options"
                    [placeholder]="filter.placeholder"
                    (reloadFilterOptions)="reloadFilterOptions()"
                />
            }
        }
    }
</ui-filter-container>
